import { Field, type FieldProps } from "formik";
import { ChangeEventHandler, PropsWithChildren, ReactNode } from "react";
import styles from "./select.module.css";

interface ComponentProps extends PropsWithChildren {
  label: string;
  name: string;
  placeholder?: string;
  bg?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement> | undefined;
  options?: ReactNode;
  value?: string;
  disabled?: boolean;
  asterisk?: boolean;
}

const CustomSelect: React.FC<ComponentProps> = (props) => {
  const {
    name,
    label,
    placeholder,
    bg,
    onChange,
    options,
    value,
    disabled,
    asterisk,
  } = props;

  return (
    <Field name={name}>
      {({ field, form: { touched, errors }, meta }: FieldProps) => (
        <div className={styles.container}>
          <label>
            {label} {asterisk && <span className={styles.asterisk}>*</span>}
          </label>

          <select
            {...field}
            className={styles.select}
            placeholder={placeholder}
            style={{ background: bg && bg }}
            onChange={onChange}
            value={value}
            disabled={disabled}
          >
            {!meta.value && <option value="">{placeholder}</option>}
            {options}
          </select>

          {touched && errors && <div className="error">{meta.error}</div>}
        </div>
      )}
    </Field>
  );
};

export default CustomSelect;
